import React from "react";

import { FormTasksView } from "components/FormTasksView";

const SubawardTasksView = () => {
	return (
		<FormTasksView />
	);
};

export default SubawardTasksView;
